export default currentPath => relativePath =>
    (currentPath.slice(-1) === '/' ? currentPath.slice(0, -1) : currentPath) + relativePath;
